export default __webpack_public_path__ + "static/media/background.6c6d1d1c.jpg";